import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';

/**
 * SuspensionDialogComponent displays a modal when a user's account is suspended
 * after successful login, informing them about their account status and available actions.
 */
@Component({
    selector: 'app-suspension-dialog',
    templateUrl: './suspension-dialog.component.html',
    styleUrl: './suspension-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuspensionDialogComponent {

  /**
   * Default constructor initializes the component with required services
   */
  constructor(
    public dialogRef: MatDialogRef<SuspensionDialogComponent>,
    private _router: Router,
    private _authService: AuthService,
    private _userService: UserService
  ) {}

  /**
   * Dismisses the modal and proceeds to the dashboard
   */
  public onOkClick(): void {
    this.dialogRef.close('ok');
  }

  /**
   * Cancels and logs the user out, redirecting to login page
   */
  public onCancelClick(): void {
    this._authService.logout();
    this.dialogRef.close('cancel');
  }

  /**
   * Closes the dialog using the X button
   */
  public onCloseClick(): void {
    this.dialogRef.close();
  }
}
